export const AVAILABLE = "AVAILABLE";
export const ERRORED = "ERRORED";
export const NOT_VALIDATED = "NOT_VALIDATED";
export const UNAVAILABLE = "UNAVAILABLE";
export const SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE";
export const VALIDATING = "VALIDATING";
